/* eslint-disable react/prop-types */
import { inject, observer } from "mobx-react";
import { Preloader } from "randmarcomps";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RootStore } from "../stores/rootStore";
import { manager } from "../stores/user/UserStore";

interface IProps {
  store?: RootStore;
}

const SignInRedirect: React.FC<IProps> = ({ store }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleSigninCallback = async () => {
      try {
        const user = await manager.signinRedirectCallback();
        await store!.userStore.storeUser(user);
        if (!user.state || user.state === "/") {
          navigate("/" + user.profile.ApplicationId);
        } else {
          navigate(user.state as string);
        }
      } catch (error) {
        console.error("Sign-in redirect failed:", error);
      }
    };

    handleSigninCallback();
  }, [navigate, store]);

  return (
    <Preloader
      className="fixed inset-0 bg-[#8E77A6]"
      color="white"
      text="Signing in..."
    />
  );
};

export default inject("store")(observer(SignInRedirect));
